import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "help-page" };
const _hoisted_2 = {
    class: "help-panel",
    role: "status"
};
const _hoisted_3 = {
    class: "help-mark",
    "aria-hidden": "true"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CircleHelp = _resolveComponent("CircleHelp");
    return (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("header", { class: "page-header" }, [
            _createElementVNode("p", { class: "eyebrow" }, "SUPPORT"),
            _createElementVNode("h1", null, "Help")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, [
                _createVNode(_component_CircleHelp, { size: 23 })
            ]),
            _cache[0] || (_cache[0] = _createElementVNode("div", null, [
                _createElementVNode("h2", null, "How can we help?"),
                _createElementVNode("p", null, "Find guidance for your account, orders, and other parts of the client portal. Support resources will be available here soon.")
            ], -1))
        ])
    ]));
}
